export default __webpack_public_path__ + "static/media/0_ru.c6d615b7.png";